import axios, { Axios } from "axios";
import * as cm from './CookieManagement';
import React from "react";

const CLIP_ALREADY_IN_LIST = 0;
const CLIP_ADDED_SUCCESSFULLY_INTO_LIST = 1;

const CLIP_URL = "CLIP_URL"
const TITLE = "TITLE"

function bookmarkIsAlreadyInList(bookmarks,bookmark){

    if(bookmarks==null){
        return false
    }

    for(const bookmark_check of bookmarks){
        if(bookmark_check[CLIP_URL]==bookmark[CLIP_URL])
            return true;
    }
    
    return false;
}

function removeBookmarkFromList(bookmark){
    let bookmarks = loadBookmarksFromLocalStorage()
    bookmarks = bookmarks.filter((v,i)=>bookmark[CLIP_URL]!==v[CLIP_URL])
    cm.saveToLocalStorage("bookmarks", bookmarks);
}

function addBookmark(clipUrl, title){
    let bookmarks = cm.loadFromLocalStorage("bookmarks");
   
    let bookmark = new Object();
    bookmark[TITLE] = title;
    bookmark[CLIP_URL] = clipUrl

    if(bookmarkIsAlreadyInList(bookmarks,bookmark)){
        return CLIP_ALREADY_IN_LIST;
    }

    if(bookmarks == null){
        bookmarks = [];
    }
     
    bookmarks.push(bookmark);

    cm.saveToLocalStorage("bookmarks", bookmarks);
    return CLIP_ADDED_SUCCESSFULLY_INTO_LIST;

}

function loadBookmarksFromLocalStorage(){
    let bookmarks = cm.loadFromLocalStorage("bookmarks");
    console.log("bookmarks")
    console.log(bookmarks)
    if(bookmarks==null){
        return [];
    }
    else 
        {
        return bookmarks;
    }
}

export {CLIP_URL, TITLE,CLIP_ALREADY_IN_LIST,CLIP_ADDED_SUCCESSFULLY_INTO_LIST,addBookmark,loadBookmarksFromLocalStorage,removeBookmarkFromList}